import { hasLoggedInCookie } from '@helsenorge/framework-utils/cookie';

import { isOnAutosignoutPage } from './isOnAutosignoutPage';

export const isSignedOutAutomatically = (): boolean => !hasLoggedInCookie() && isOnAutosignoutPage();
